export default __webpack_public_path__ + "static/media/top-k-6.6ed78c3e.jpg";